import { render, staticRenderFns } from "./CanceledProposals.vue?vue&type=template&id=5a076768&scoped=true&"
import script from "./CanceledProposals.vue?vue&type=script&lang=js&"
export * from "./CanceledProposals.vue?vue&type=script&lang=js&"
import style0 from "./CanceledProposals.vue?vue&type=style&index=0&id=5a076768&prod&lang=css&"
import style1 from "./CanceledProposals.vue?vue&type=style&index=1&id=5a076768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a076768",
  null
  
)

export default component.exports